import { render, staticRenderFns } from "./zcfzb.vue?vue&type=template&id=4b242fba&scoped=true&"
import script from "./zcfzb.vue?vue&type=script&lang=js&"
export * from "./zcfzb.vue?vue&type=script&lang=js&"
import style0 from "./zcfzb.vue?vue&type=style&index=0&id=4b242fba&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b242fba",
  null
  
)

export default component.exports